import '@intec/vue-components/main.css';
import '../styles/app.css';
import '../fonts/Abrade/stylesheet.css';
import '@mdi/font/css/materialdesignicons.css';
import './polyfills';
import * as coreModule from '@/index';

import { createApp } from 'vue';
import { createPinia } from "pinia";
import mitt from 'mitt';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueTheMask from 'vue-the-mask';
import Vue3Toastify from 'vue3-toastify';

import { makeRouter } from './routes';
import Config from './config';

import App from './components/App';
import AppBar from './components/AppBar';
import PageHeader from './components/PageHeader';
import Alerts from '@/plugins/alerts';

import { registerVuetify } from '@/plugins/vuetify';
import i18n from '@/plugins/i18n'

import 'vue3-toastify/dist/index.css';
import { useLibraryStore } from "@/stores/library";
import { addMessegesFromModule } from '@/plugins/i18n/utils';

export const emitter = mitt();

export const app = createApp(App);
const pinia = createPinia();

app.provide('emitter', emitter);
app.use(VueAxios, axios);
app.use(Alerts);
app.use(pinia);
app.use(VueTheMask);
app.use(Vue3Toastify, {
  autoClose: 3000,
});

app.component('app-bar', AppBar);
app.component('page-header', PageHeader);

// export const eventBus = new Vue();

app.config.globalProperties.$axios = axios;
export let router = null;

export function initial(modules = [], themeData) {
  modules = [{name: 'core', module: coreModule}, ...modules];
  Config.reload().then(() => {
    const user = Config.getUser();
    i18n.global.locale = user.getLang();
    router = makeRouter(user);

    const libraryStore = useLibraryStore();
    modules.forEach(item => {
      const module = item.module.default || item.module
      addMessegesFromModule(i18n, module)
      app.use(i18n);
      libraryStore.addLibrary(item.name, module);
    })

    app.use(router);
    const config = {
      ...themeData,
      usePhoneMask: themeData?.usePhoneMask ?? true,
      logoPath: themeData?.logoPath ?? '/bundles/cetpcore/images/logo_dots.svg',
      iconPath: themeData?.iconPath ?? '/bundles/cetpcore/favicon.ico',
      showNavBarItemsForGuest: themeData?.header?.showNavBarItemsForGuest === true,
    };

    app.provide('themeData', config);
    app.config.globalProperties.$themeData = config;

    router.isReady().then(() => app.mount('#app'));

    registerVuetify(app, themeData, i18n);
  });
}
